import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const BenefitIMG = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 66.666%;

  ${maxMediaQueries.tablet`
    width: calc(100% - 24px);
    ${({ right }) => right && 'right: -24px;'};
  `};
`;
